const Styles = theme => ({
  formBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  paperforpopup: {
    width: "27.91vw",
    height: "36.42vh"
  },
  paper: {
    display: "flex",
    width: "50vw",
    height: "50vh"
  },
  formtitle: {
    width: "97%",
    fontSize: "28px",
    color: "#304D6E",
    // fontVariant: 'all-small-caps',
    marginBottom: "25px",
    fontWeight: "600"
  },
  loginbutton: {
    width: "100%",
    backgroundColor: "#F54040",
    color: "white",
    marginBottom: "15px",
    "&:hover": {
      backgroundColor: "#F54040",
      opacity: 0.75
    }
  },
  spinner: {
    height: "15px",
    width: "15px",
    position: 'absolute',
    right: 0,
    marginRight: theme.spacing(1)
    // marginRight: "7px"
  },
  popupbutton: {
    widht: "45%",
    backgroundColor: "#F54040",
    color: "white",

    "&:hover": {
      backgroundColor: "#F54040",
      opacity: 0.75
    }
  },
  popupCancelButton: {
    widht: "45%",
    borderColor: "#F54040",
    color: "#F54040",
    marginRight: 15,
    "&:hover": {
      opacity: 0.75
    }
  },
  errormsg: {
    color: "red"
  },
  fgtpasswdlink: {
    fontWeight: "500",
    color: "#00518B",
    fontSize: "14px",
    letterSpacing: "0",
    textTransform: "capitalize",
    opacity: 1,
    textDecoration: "none"
  },
  infomsg: {
    fontSize: "13px",
    letterSpacing: "0",
    color: "#006CA8",
    opacity: 1,
    // width: "97%",
    maxWidth: 240,
    fontWeight: "500",
    // [theme.breakpoints.down('lg')]: {
    //   width: 240,
    //   // height: 350,
    // },
    // [theme.breakpoints.down('md')]: {
    //   width: 800,
    //   // height: 350,
    // },
    // [theme.breakpoints.down('sm')]: {
    //   height: "50vh",
    //   // width: "55vw",
    // },
  },
  btn: {
    width: "10.4vw",
    height: "4.12vh",
    backgroundColor: "#F54040",
    marginBottom: "15px",
    "&:hover": {
      backgroundColor: "#F54040",
      opacity: 0.75
    }
  }
});

export default Styles;
